module.exports = __webpack_public_path__ + "static/media/avatarLarge.209b6f6e.svg";